var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#63717A;}\r\n\t.st2{fill:#592D81;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.8,44l-38.1,38.3l-31.9-31.8l-31.9,31.8L200,50.4l-31.8,31.8l-31.8-31.8l-31.8,31.9L67.6,44.8v169.3 c0,73.7,59.1,133.6,132.7,133.6s133.5-59.9,133.5-133.6V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.5,237.3c3.1,16,9.4,30.9,18.5,44.7c5.6-9.8,16.6-21.7,38.4-26.9c-1.6-5.6-3.1-11.5-4.4-17.7L79.5,237.3 L79.5,237.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,293.4c23.5,27.6,57.4,43.4,93,43.6c-3.4-1.7-6.6-3.6-9.9-5.7c-15.1-9.8-35.9-28.8-49.3-64.1 C119.4,271.9,110.4,283.9,106.7,293.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.6,265.5c9.6,24,24,42.4,42.8,54.8c12.5,8.2,24.5,11.8,32.3,13.6c19.8-4.5,38.2-14.1,53.5-27.6 c-12-1.3-24.5-8.2-37.4-15.5c-20.4-11.4-45.7-25.6-80-25.6C161.2,265,157.4,265.1,153.6,265.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205,174.9h-43.9v52.4h18.3v-42.1h13.7v42.1h17.4v-45C210.5,178.4,208,174.9,205,174.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.1,174.9v45c0,4,2.5,7.4,5.4,7.4h28.8h15.2v-31.9H250v21.4h-13.7v-31.9h31.3v-10.1L218.1,174.9 L218.1,174.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "112.3,174.9 102.4,196.2 96.7,196.2 96.7,174.9 78.4,174.9 78.4,227.4 96.7,227.4 96.7,206.3  102.4,206.3 112.3,227.4 130.5,227.4 117.8,201.3 130.5,174.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.3,
    y: 174.9,
    className: "st2",
    width: 18.8,
    height: 52.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M323,189.2V175h-48.3v24c0,4,2.5,7.2,5.4,7.2h24.6v11.4h-30.1v9.9h48.3v-24.1c0-3.7-2.1-7.2-4.8-7.2h-25.4v-11 h12.7v4L323,189.2L323,189.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "271.5,121.9 256.2,121.9 287.9,90 263.8,65.9 231.9,97.7 200,65.9 144.2,121.9 128.7,121.9  160.6,89.9 136.5,65.9 104.8,97.7 78.4,71.6 78.4,123.8 78.4,165.4 323,165.4 323,125 323,70.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.9,155.3c0,1.3,1,2.5,2.5,2.5H148v-3.6h-11.2v-11.9H148v-3.7h-16.2V155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.4,138.5v19.3h4.9v-5h6.3v5h4.9v-16.9c0-1.4-1.1-2.5-2.8-2.5H109.4L109.4,138.5z M120.6,149.1h-6.3v-6.9 h6.3V149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.3,138.5H300c-1.3,0-2.5,1-2.5,2.5v14.4c0,1.3,1,2.5,2.5,2.5h11.3c1.3,0,2.5-1.1,2.5-2.5v-14.4 C313.9,139.5,312.8,138.5,311.3,138.5 M308.9,154h-6.2v-11.9h6.2V154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,147.5c0,1.3,1,2.5,2.5,2.5h8.7v4.2H87v3.7h16.2v-9.1c0-1.2-0.9-2.4-2.3-2.5h-0.1h-8.9v-4.2h11.2v-3.7H87 V147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190,138.5h-13.7v19.3h4.9v-5h6.3v5h4.9v-16.9C192.5,139.5,191.3,138.5,190,138.5 M187.4,149.1h-6.3v-6.9h6.3 V149.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "275.8,142.1 281.5,142.1 281.5,157.8 286.4,157.8 286.4,142.1 292,142.1 292,138.5 275.8,138.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,138.5h-24.9v19.3h4.9v-15.6h6.2v15.6h5v-15.6h6.2v15.6h4.9v-16.9C226.4,139.5,225.3,138.5,224,138.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.3,138.5h-13.8v19.3h4.9v-15.6h6.3v15.6h4.9v-16.9C270.8,139.5,269.7,138.5,268.3,138.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.2,155.3c0,1.3,1,2.5,2.5,2.5h13.7v-3.6h-11.2v-4.2h11.2v-3.7h-11.2V142h11.2v-3.6h-16.2V155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.3,150.7h2.7v-9.9c0-1.4-1.1-2.5-2.8-2.5h-13.5v19.3h4.9v-7h3.6l3,7h4.8L167.3,150.7z M165.1,147h-6.3 v-4.9h6.3V147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,252.1c26-0.5,51.9,6.1,84.7,24.7c24.3,13.8,35,18,42.3,16.3c6.7-1.6,13-5.7,24-28.8 c4.2-8.9,7.2-19.3,8.6-27H145c1.2,5.4,2.5,10.7,4.1,15.5C153.3,252.4,157.8,252.1,162.1,252.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSac);
export default __webpack_public_path__ + "static/media/SAC.05f426e5e8969b1d93e153fe9ae1081c.svg";
export { ForwardRef as ReactComponent };